export default {
  All: 'all',
  UsageOnly: 'usageOnly',
  PurchaseOnly: 'purchasesOnly',
}
